
<div class="dashboard-content-sec ">
    <div class="loader" *ngIf="showloader">
        <img src="assets/images/loader.gif" alt="">
    </div>

    <form (ngSubmit)="saveState()" [formGroup]="form">
        <div class="row form-section">
            <div class="col">
                <div class="card mb-0">
                    <app-breadcrumb [crumbList] = "crumbList"></app-breadcrumb>
                    <div class="card-title">
                        <!-- <h5 class="fa fa-building">
                          {{ this.title }}
                        </h5> -->

                        <a id="client-expand" style="color:black" 
                            data-toggle="collapse" class="p-2 fa fa-expand" 
                            href="#stateTable" (click)="swapIcon($event)">
                            {{StateCtrl.value}} Profile</a>

                        <div class="float-right">
                            <button type="submit" class="btn btn-default align-items-end" tabindex="100">Save</button>
                        </div>
                    </div>

                    <div class="card-form" id="stateTable" class="collapse show">

                        <div *ngIf="submitted && this.form.invalid" class="invalid-feedback">
                            <span >Please review for the form for invalid fields</span>
                        </div>

                        <div *ngIf="this.successful_result"
                            class="alert alert-success" role="alert">
                            Successfully saved record
                        </div>
                        <div *ngIf="this.error_result" class="alert alert-danger" role="alert">
                            Unable to save record. Error occurred.
                        </div>

 
                        <div class="form-row" >
                            <label class='col-sm-2'>State</label>
                            <div class='form-group col-sm-2'>
                                <select name="State" class="form-control" formControlName="State" tabindex="2">
                                    <!-- <option selected value="">Please select Client</option> -->
                                    <option id="{{state.Code}}" value="{{state.Code}}" 
                                            *ngFor="let state of stateCodes">{{state.Value}}
                                    </option>

                                </select>

                                <div *ngIf="StateCtrl.invalid && (StateCtrl.dirty || StateCtrl.touched)"
                                    class="invalid-feedback">
                                    <div>
                                        <span>State is required.</span>
                                    </div>
                                </div>        
                            </div>
                        </div>


                        <div class="form-row">
                            <label class="col-sm-2" for="NewUpdates">New Update Count</label>                                    
                            <div class="form-group col-sm-2">
                                <input formControlName="NewUpdates"  id="NewUpdates"
                                name="NewUpdates" type="number" 
                                required minlength="2"
                                class="form-control" 
                                tabindex="3" placeholder="">
                            </div>
                        </div>    
                        <div *ngIf="NewUpdatesCtrl.invalid && (NewUpdatesCtrl.dirty || NewUpdatesCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="NewUpdatesCtrl.errors.required">
                                <span>New Update Count is required.</span>
                            </div>
                        </div>
                            

                        <div class="form-row">
                            <label class="col-sm-2" for="Overview">Overview</label>
                            <div class="form-group col-sm-8">
                                <textarea formControlName="Overview" type="text" rows="5"
                                    class="form-control" id="Overview" tabindex="3" placeholder="">
                                </textarea>                                
                            </div>
                        </div>
                        <div *ngIf="OverviewCtrl.invalid && (OverviewCtrl.dirty || OverviewCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="OverviewCtrl.errors.required">
                                <span>Overview required</span>
                            </div>
                        </div>           
                        


                        <div class="dashboard-content-sec mt-4">
                            <div class="card mb-0">
                                <div class="user-heading-sec">
                                    <div class="mr-4 d-inline-block">
                                        <a data-toggle="collapse" style="width:180px" class="p-2 fa fa-expand" 
                                        href="#updatesDiv" (click)="swapIcon($event)">
                                        {{updateList?.length}} State Updates</a>
                        
                                    </div>
                                    <div style='width: 140px' class="d-inline-block">
                                            <a data-toggle="collapse" href="#newStateRow" 
                                               class="fa fa-address-book btn btn-default "
                                               (click)="addUpdate()">
                                                Add Update
                                            </a>                        
                                        </div>       
                        
                                </div>
                        
                                <div id="updatesDiv" class="table-responsive collapse show">
                                    <table id="statesTable" 
                                        class="table user-table table-striped">
                                        <thead>
                                            <tr>
                                                <th scope="col">Title</th>
                                                <th scope="col" class="">Effective Date</th>
                                                <th scope="col" class="">Law</th>
                                                <th scope="col" class="">What To Do</th>
                                                <th scope="col" class="">Remove</th >
                                            </tr>
                                        </thead>
                        
                                        <tbody>
                                            <ng-container *ngFor="let update of updateList">
                                                <tr id="state-row{{update.ID}}">
                                                    <td >
                                                        <a href="#newStateRow" data-toggle="collapse"
                                                           (click)="openMe(update.ID)">
                                                            {{ update.Title?.substring(0,30).trim() }}...
                                                        </a>                                                        
                                                    </td>
                                                    <td >
                                                        <a href="#newStateRow"  data-toggle="collapse"
                                                          (click)="openMe(update.ID)">
                                                            {{ update.EffectiveDate }}
                                                        </a>                                                        
                                                    </td>
                                                    <td >
                                                        <a href="#newStateRow" data-toggle="collapse"
                                                          (click)="openMe(update.ID)">
                                                            {{ update.Law?.substring(0,30).trim() }}...
                                                        </a> 
                                                    </td>
                                                    <td >
                                                        <a  href="#newStateRow" data-toggle="collapse"
                                                        (click)="openMe(update.ID)">
                                                            {{ update.WhatToDo?.substring(0,30).trim() }}...
                                                        </a >                                                        
                                                    </td>
                                                    
                                                    <td>
                                                        <div class="d-inline-block">
                                                            <a id="del-state{{update.ID}}" title="Remove" class="btn fa fa-times"
                                                            (click)="deleteUpdate(update.ID)"> </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                            
                                        </tbody>
                                        <ng-container *ngIf="updateList?.length == 0">
                                            <tr><td colspan="5">No Result Found</td></tr>
                                        </ng-container>                                 
                       
                                    </table>

                                    <div class="collapse" id="newStateRow">
                                        <div class="card">
                                            <input type="hidden" id="ID">
                                            <div class="float-right">
                                                <button (click)="saveUpdate()" class="btn btn-default align-items-end float-right" tabindex="100">Save</button>
                                            </div>
                    
                                            <div class="form-row">
                                                <label class="col-sm-2">Title</label>
                                                <div class="form-group col-sm-4">
                                                    <input id="Title"
                                                         class="form-control"
                                                         type="text"
                                                         maxlength="200" >
                                                </div>
                                            </div>

                                            <div class="form-row">
                                                <label class="col-sm-2">Effective Date</label> 
                                                <div class="col-sm-4">
                                                    <div class="input-group">
                                                        <input class="form-control" placeholder="yyyy-mm-dd"
                                                            name="dp" id="EffectiveDate" 
                                                            data-container="body"
                                                            ngbDatepicker #d="ngbDatepicker"
                                                            style="width: 200px ">
                                                            
                                                            <div class="input-group-append">
                                                                <button class="btn btn-outline-secondary calendar fa fa-calendar" 
                                                                    (click)="d.toggle()" type="button"></button>
                                                            </div>
                                                    </div>
                                                </div>
                                            </div> 


                                            <div class="form-row mt-3">
                                                <label class="col-sm-2">Law</label>
                                                <div class="form-group col-sm-12">
                                                    <div id="Law" [froalaEditor]="options" [(froalaModel)]="lawContent"></div>
                                                </div>
                                            </div>
                                            <div class="form-row mt-3">
                                                <label class="col-sm-2">What To Do</label>
                                                <div class="form-group col-sm-12">
                                                    <div id="WhatToDo" [froalaEditor]="options" [(froalaModel)]="whatToDoContent"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                    
                
                                </div>
                            </div>
                        </div>
                        


                    </div>
                </div>
            </div>
        </div>
    </form>

</div>


